import React from 'react';

import { IPostMedia } from '../../dtos/IPostProjectProps';
import { resolvePostThumbnail } from '../../utils/getPostThumbnail';

interface IPostThumbnailProps {
  photos: IPostMedia[];
  alt: string;
}

/**
 * Capa de um post em cards e listas.
 *
 * Renderiza `<img>` ou `<video>` conforme a mídia disponível — ver
 * resolvePostThumbnail. O `<video>` fica mudo, sem controles e sem tocar: ele
 * está aqui só para o navegador desenhar o primeiro quadro como capa.
 *
 * O fragmento `#t=0.1` é o que faz esse quadro aparecer. Sem ele, com
 * `preload="metadata"`, boa parte dos navegadores mostra um retângulo preto —
 * o mesmo detalhe que o player do feed já usa.
 *
 * Quem usar precisa aceitar `video` no seletor de estilo, não só `img`.
 */
const PostThumbnail: React.FC<IPostThumbnailProps> = ({ photos, alt }) => {
  const thumbnail = resolvePostThumbnail(photos);

  if (thumbnail.kind === 'video') {
    return (
      <video
        src={`${thumbnail.url}#t=0.1`}
        preload="metadata"
        muted
        playsInline
        aria-label={alt}
      />
    );
  }

  return <img src={thumbnail.url} alt={alt} />;
};

export default PostThumbnail;
